
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"10","height":"18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M1.293 18c.075-.005.095-.005.17-.018a1.234 1.234 0 00.671-.358l7.5-7.714c.053-.057.067-.07.113-.133a1.328 1.328 0 000-1.554c-.046-.062-.06-.075-.112-.132L2.135.377C2.078.323 2.065.308 2.004.26A1.237 1.237 0 001.038.02C.925.039.816.074.713.125c-.39.19-.662.587-.706 1.03a1.325 1.325 0 00.247.908c.046.062.06.075.112.132L6.983 9 .366 15.806l-.058.064c-.048.06-.062.075-.103.14a1.307 1.307 0 00-.204.749c.014.444.26.859.636 1.077.124.072.26.121.4.146.076.013.095.013.17.018h.086z","fill":"currentColor"}})])
          )
        }
      }
    